import PageMain from "@/components/page-main"
import { Button, Space, Input } from 'antd';
import React, { useState, useMemo, useEffect } from 'react';

import Loading from "@/components/loading";

import { history, Access, useAccess, useDispatch, useSelector } from 'umi';

import useFetch from '@/hooks/useFetch';
import useStaff from "@/hooks/useStaff";

const { Search } = Input;

type Staff = { name: string; userid: string; }

const Index: React.FC = () => {
  const [keyword, setKeyword] = useState<string>("");

  const { data, loading } = useStaff();

  const currentStaff: Staff[] = useMemo(() => {
    return data.filter((item: Staff) => item?.name.includes(keyword))
  }, [keyword, data]);

  const handleSearch = (value: string) => setKeyword(value);

  return <PageMain>
    <Space direction="vertical">
      <Search placeholder="查找" onChange={(e) => handleSearch(e.target.value)} style={{ width: 200 }} />
      {
        currentStaff.length ? <div style={{ display: "flex", flexWrap: "wrap" }}>
          {
            currentStaff.map((item: Staff) => <Button style={{ marginBottom: 10, marginRight: 10 }} onClick={() => history.push(`/wecom/permission/${item.userid}`)}>
              {item.name}-{item.userid}
            </Button>)
          }
        </div> : <></>
      }
    </Space>
    <Loading loading={loading} />
  </PageMain>
}

export default Index;